import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class SurveyViewsBaseService {
    constructor(private httpClient: HttpClient) { }

    getResourceDetails(resourceId: string): Observable<any> {
        const url = ecorEnv.apiEndpoint + '/secure/pega/attachments/' + encodeURIComponent(resourceId);
        return this.httpClient.get<any>(url)
            .pipe(
                catchError(this.handleError)
            );
    }

    getResourceFilename(resourceId: string): Observable<any> {
        const url = ecorEnv.apiEndpoint + '/secure/pega/attachmentfilename/' + encodeURIComponent(resourceId);
        return this.httpClient.get<any>(url, { responseType: 'text' as 'json' })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('surveys-view-base', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys-view-base', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
